import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store/index.ts'

const routes: Array<RouteRecordRaw> = [
      {
        path: '/',
        name: 'Home',
        component: ()=> import('../views/Home.vue'),
        meta:{
          requiresAuth: true
        }
      },

      {
        path: '/login',
        name: 'Login',
        component: ()=> import('../views/Login.vue'),
      },

      {
        path: '/demandemdp',
        name: 'MotDePasseOublie',
        component: () => import('../views/connexion/MotDePasseOublie.vue'),
      },

      {
        path: '/resetPassword/:token',
        name: 'ResetPassword',
        component: () => import('../views/connexion/ResetPassword.vue'),
        props: true,
      },

      {
        path:'/execution/:code',
        name: 'JustificationSansConnexion',
        component: () => import('../views/JustificationSansConnexion.vue'),
      },

      {
      path: '/requetes',
      name: 'Requetes',
      component: () => import('../views/Requete/RequeteList.vue'),
      meta:{
        requiresAuth: true
      }
    },

    {
      path: '/jeuRequetes',
      name: 'jeuRequetes',
      component: () => import('../views/JeuRequetes/jeuRequeteList.vue'),
      meta:{
        requiresAuth: true
      }
    },

    {
      path: '/lancement',
      name: 'lancement',
      component: () => import('../views/Lancement/Lancement.vue'),
      meta:{
        requiresAuth: true
      }
    },

    {
      path: '/rapports',
      name: 'rapports',
      component: () => import('../views/Rapport/Rapport.vue'),
      meta:{
        requiresAuth: true
      }
    },

      {
        path: '/rapports/:idExecution',
        name: 'rapportsDepuisMail',
        component: () => import('../views/Rapport/RapportDepuisMail.vue'),
        meta:{
          requiresAuth: true
        }
      },
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth as boolean;
  // Permet l'accès à la route de réinitialisation du mot de passe sans authentification
  if (to.name === 'ResetPassword') {
    next();
    return;
  }

  // Si la route nécessite une authentification et l'utilisateur n'est pas connecté, redirige vers "/login"
  if (requiresAuth && !store.getters.isLoggedIn) {
    next('/login');
    return;
  }

  // Si l'utilisateur est déjà connecté et essaie d'accéder à "/login" ou "/demandemdp", redirige vers "/"
  if (store.getters.isLoggedIn && (to.path === '/login' || to.path === '/demandemdp')) {
    next('/');
    return;
  }

  // Vérifie si la route demandée existe
    const availableRoutes = router.getRoutes().map(route => route.path);
    const routeExists = availableRoutes.some(path => {
        const regex = new RegExp(`^${path.replace(/:\w+/g, '\\w+')}$`);
        return regex.test(to.path);
    });

    if (!routeExists) {
        console.log("La route n'existe pas:", to.fullPath);
        next('/');
        return;
    }
  next()
})

export default router
